import { render } from "./user-report-table.vue?vue&type=template&id=562052cc"
import script from "./user-report-table.vue?vue&type=script&lang=js"
export * from "./user-report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__